import logo from "./logo.svg";
import "./App.css";
import { getAuth, signInWithEmailAndPassword, signOut } from "firebase/auth";
import { useAuthState } from "react-firebase-hooks/auth";
import { initializeApp } from "firebase/app";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCloud,
  faUser,
  faHammer,
  faLightbulb,
  faBook,
  faSignOutAlt,
  faBell,
  faMusic,
  faSearch,
  faFileContract,
  faMoon,
  faChartLine,
  faTag,
} from "@fortawesome/free-solid-svg-icons";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Card, Button, Row, Col, Form } from "react-bootstrap";
import { useState } from "react";

// Firebase config and initialization
const firebaseConfig = {
  apiKey: "AIzaSyBBzepSPN2wdZfvan5GgyeeIREAV6k5BaU",
  authDomain: "loftie-4f472.firebaseapp.com",
  databaseURL: "https://loftie-4f472.firebaseio.com",
  projectId: "loftie-4f472",
  storageBucket: "loftie-4f472.appspot.com",
  messagingSenderId: "302939981606",
  appId: "1:302939981606:web:7fcb10ed6fe46fa437a3e7",
  measurementId: "G-L8VGQXX28P",
};

const firebaseApp = initializeApp(firebaseConfig);
const auth = getAuth(firebaseApp);

function App() {
  const [user, userLoading] = useAuthState(auth);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const iconStyle = {
    color: "#F0D6B5",
  };

  return userLoading ? (
    <Container className="d-flex justify-content-center align-items-center">
      Loading...
      <h1 className="text-center mb-4" style={{ color: "#F0D6B5" }}>
        Loftie Dashboard
      </h1>
    </Container>
  ) : user ? (
    <div className="App">
      <Container>
        <Spacer height={45} />
        <h1 className="text-center mb-4" style={{ color: "#F0D6B5" }}>
          Loftie Dashboard
        </h1>

        {/* Top-right section with email and sign-out */}
        <div
          style={{
            position: "absolute",
            top: 20,
            right: 20,
            display: "flex",
            alignItems: "center",
            color: "#635956",
          }}
        >
          <span style={{ marginRight: 10 }}>{user.email}</span>
          <a
            href="#"
            style={{
              color: "#635956",
              textDecoration: "none",
              display: "flex",
              alignItems: "center",
            }}
            onClick={() => signOut(auth)}
          >
            <FontAwesomeIcon
              icon={faSignOutAlt}
              size="lg"
              style={{ marginRight: 5 }}
            />
            Sign Out
          </a>
        </div>

        <Row className="mt-3">
          <Col md={4}>
            <Card className="text-center">
              <Card.Body>
                <FontAwesomeIcon icon={faCloud} size="3x" style={iconStyle} />
                <Card.Title>
                  <a
                    href="/loftie"
                    style={{ color: "#635956", textDecoration: "none" }}
                  >
                    Loftie Search
                  </a>
                </Card.Title>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="text-center">
              <Card.Body>
                <FontAwesomeIcon icon={faUser} size="3x" style={iconStyle} />
                <Card.Title>
                  <a
                    href="/user"
                    style={{ color: "#635956", textDecoration: "none" }}
                  >
                    User Search
                  </a>
                </Card.Title>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="text-center">
              <Card.Body>
                <FontAwesomeIcon icon={faHammer} size="3x" style={iconStyle} />
                <Card.Title>
                  <a
                    href="/tools"
                    style={{ color: "#635956", textDecoration: "none" }}
                  >
                    Tools
                  </a>
                </Card.Title>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col md={4}>
            <Card className="text-center">
              <Card.Body>
                <FontAwesomeIcon
                  icon={faLightbulb}
                  size="3x"
                  style={iconStyle}
                />
                <Card.Title>
                  <a
                    href="/refurb"
                    style={{ color: "#635956", textDecoration: "none" }}
                  >
                    Refurb Lofties
                  </a>
                </Card.Title>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="text-center">
              <Card.Body>
                <FontAwesomeIcon icon={faBook} size="3x" style={iconStyle} />
                <Card.Title>
                  <a
                    href="/storymaker"
                    style={{ color: "#635956", textDecoration: "none" }}
                  >
                    Storymaker
                  </a>
                </Card.Title>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="text-center">
              <Card.Body>
                <FontAwesomeIcon icon={faBell} size="3x" style={iconStyle} />
                <Card.Title>
                  <a
                    href="/notificationCenter"
                    style={{ color: "#635956", textDecoration: "none" }}
                  >
                    Notification Center
                  </a>
                </Card.Title>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Spacer height={20} />
        <Row>
          <Col md={4}>
            <Card className="text-center">
              <Card.Body>
                <FontAwesomeIcon icon={faMusic} size="3x" style={iconStyle} />
                <Card.Title>
                  <a
                    href="/audioCenter"
                    style={{ color: "#635956", textDecoration: "none" }}
                  >
                    Audio Center
                  </a>
                </Card.Title>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="text-center">
              <Card.Body>
                <FontAwesomeIcon icon={faSearch} size="3x" style={iconStyle} />
                <Card.Title>
                  <a
                    href="/macLookUp"
                    style={{ color: "#635956", textDecoration: "none" }}
                  >
                    Mac Address Search
                  </a>
                </Card.Title>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="text-center">
              <Card.Body>
                <FontAwesomeIcon icon={faMoon} size="3x" style={iconStyle} />
                <Card.Title>
                  <a
                    href="/nightSchool"
                    style={{ color: "#635956", textDecoration: "none" }}
                  >
                    Night School
                  </a>
                </Card.Title>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="text-center">
              <Card.Body>
                <FontAwesomeIcon
                  icon={faFileContract}
                  size="3x"
                  style={iconStyle}
                />
                <Card.Title>
                  <a
                    href="/subscriptionContracts"
                    style={{ color: "#635956", textDecoration: "none" }}
                  >
                    Subscription Contracts
                  </a>
                </Card.Title>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Spacer height={20} />
        <Row>
          <Col md={4}>
            <Card className="text-center">
              <Card.Body>
                <FontAwesomeIcon
                  icon={faChartLine}
                  size="3x"
                  style={iconStyle}
                />
                <Card.Title>
                  <a
                    href="/subscriptionAnalytics"
                    style={{ color: "#635956", textDecoration: "none" }}
                  >
                    Subscription Analytics
                  </a>
                </Card.Title>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="text-center">
              <Card.Body>
                <FontAwesomeIcon icon={faTag} size="3x" style={iconStyle} />
                <Card.Title>
                  <a
                    href="/discountAnalytics"
                    style={{ color: "#635956", textDecoration: "none" }}
                  >
                    Discount Analytics
                  </a>
                </Card.Title>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="text-center">
              <Card.Body>
                <FontAwesomeIcon
                  icon={faChartLine}
                  size="3x"
                  style={iconStyle}
                />
                <Card.Title>
                  <a
                    href="/featureAnalytics"
                    style={{ color: "#635956", textDecoration: "none" }}
                  >
                    Feature Analytics
                  </a>
                </Card.Title>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  ) : (
    <div className="App">
      <Container>
        <Spacer height={45} />
        <h1 className="text-center mb-4" style={{ color: "#F0D6B5" }}>
          Loftie Dashboard
        </h1>
        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
          <Form.Control
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="name@example.com"
          />
        </Form.Group>
        <Form.Group className="mb-3" controlId="exampleForm.ControlInput2">
          <Form.Control
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="password"
          />
        </Form.Group>
        <Button
          variant="primary"
          type="submit"
          onClick={() => signInWithEmailAndPassword(auth, email, password)}
        >
          Sign In
        </Button>
      </Container>
    </div>
  );
}

const Spacer = ({ width, height }) => {
  return <div style={{ width: width || 1, height: height || 1 }}></div>;
};

export default App;
